import {gsap} from "gsap";

const RentalAccessories = {
    init(animate) {
        this.el = $('[module="rental"][section="accessories"]');
        if (!this.el.length) return;

        this.buttons = this.el.find('button.toCart');
        this.continueBtn = this.el.find('.button.continue');
        this.boxes = this.el.find('[component="Box"]');

        this.bind();
        if (animate) this.animate();
    },

    bind() {
        this.buttons.on('click', (evt) => this.update(evt));
        this.continueBtn.on('click', this.continue);
    },

    animate() {
        gsap.from(this.boxes, {opacity: 0, y: 100, stagger: 0.07, duration: 0.7, clearProps: true})
    },

    update(evt) {
        const btn = $(evt.currentTarget).attr('load', '');
        const box = btn.closest('[component="Box"]');
        const total = box.find('.together');
        let totalString = '0€'
        const id = box.attr('item');
        const input = $('.actions [class="value"]', box);
        const max = parseInt(input.attr('max'));
        let count = parseInt(input.val());
        const step = parseInt(btn.attr('step'));
        const price = parseFloat(box.attr('price'));

        box.find('button.toCart').removeClass('disabled');

        count += step;

        if (count === max) {
            btn.addClass('disabled');
        } else if (count === 0) {
            btn.addClass('disabled');
        } else if (count > max) {
            return;
        } else if (count < 0) {
            return;
        }

        if (count > 0) {
            box.addClass('active');
            totalString = (price * count) + '€ / ' + count + window.T.rental.piece
        } else {
            totalString = '0€'
            box.removeClass('active')
        }

        input.val(count);
        total.text(totalString);

        Rental.load(null, {
            accessory: id,
            count: count,
        })
    },

    continue(evt) {
        evt.preventDefault();
        Rental.load("/" + window.T.rental.base_url + "/" + window.T.rental.sections.summary.url, null, 1)
    }
}

export default RentalAccessories;